import * as React from 'react';
import { translate, Translate } from 'react-jhipster';
import { Row, Col, Alert, Button, FormGroup, Label } from 'reactstrap';
import { AvForm, AvField, AvGroup } from 'availity-reactstrap-validation';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import Recaptcha = require('react-recaptcha');
import { RouteComponentProps } from 'react-router-dom';
import { onlineEnquiry, reset } from './static-page.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';

export interface IContactUsProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface IContactUsState {
  recaptcha: string;
}

export class ContactUs extends React.Component<IContactUsProps, IContactUsState> {
  state: IContactUsState = {
    recaptcha: ''
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleValidSubmit = (event, values) => {
    this.props.onlineEnquiry(values);
    event.preventDefault();
  };

  verifyCallback = response => {
    this.setState({ recaptcha: response });
  };

  render() {
    // TODO: good to put logic here? Go to next step if get token success
    if (this.props.enquirySuccess) {
      // this.form && this.form.reset();
      this.props.reset();
      this.props.history.push('/home');
    }

    return (
      <Row className="justify-content-center">
        <Col md="8" className="bg-white">
          <Row className="justify-content-center">
            <Col md="8" className="m-3">
              <h1>
                <Translate contentKey="static.contactus.title">Contact Us</Translate>
              </h1>
              <h2>
                <Translate contentKey="static.contactus.cs">Customer Service</Translate>
              </h2>
              <p>
                <FontAwesomeIcon icon="phone" />&nbsp;<a href="tel:">(852) 5667 6376</a>{' '}
                <Translate contentKey="static.contactus.officehour">Monday to Friday</Translate>
              </p>
              <FontAwesomeIcon icon="envelope" />&nbsp;<a href="mailto:cs@patotix.com">cs@patotix.com</a>
              <AvForm id="register-form" onValidSubmit={this.handleValidSubmit}>
                <AvField
                  name="name"
                  label={translate('global.form.name')}
                  validate={{
                    required: { value: true, errorMessage: translate('register.messages.validate.login.required') },
                    maxLength: { value: 50, errorMessage: translate('global.messages.validate.email.maxlength') }
                  }}
                />
                <AvField
                  name="email"
                  label={translate('global.form.email')}
                  type="email"
                  validate={{
                    required: { value: true, errorMessage: translate('global.messages.validate.email.required') },
                    minLength: { value: 5, errorMessage: translate('global.messages.validate.email.minlength') },
                    maxLength: { value: 254, errorMessage: translate('global.messages.validate.email.maxlength') }
                  }}
                />
                <AvField
                  label={translate('global.form.phoneNumber')}
                  name="phoneNumber"
                  className="form-control"
                  type="text"
                  validate={{
                    required: { value: true, errorMessage: translate('global.messages.validate.email.required') }
                  }}
                />
                <AvField
                  label={translate('global.form.event')}
                  name="event"
                  className="form-control"
                  type="text"
                  validate={{
                    required: { value: true, errorMessage: translate('global.messages.validate.email.required') }
                  }}
                />
                <AvField
                  label={translate('global.form.query')}
                  name="query"
                  className="form-control"
                  type="textarea"
                  validate={{
                    required: { value: true, errorMessage: translate('global.messages.validate.email.required') }
                  }}
                />
                <FormGroup>
                  <Recaptcha
                    sitekey="6LfVxXMUAAAAADJel413B-Qrt76JqiumdxZe5rZF"
                    render="explicit"
                    verifyCallback={this.verifyCallback}
                    hl="zh-HK"
                  />
                  <AvField
                    name="recaptcha"
                    value={this.state.recaptcha}
                    className="d-none"
                    validate={{ required: { value: true, errorMessage: translate('register.messages.validate.recaptcha.required') } }}
                  />
                </FormGroup>
                <Button id="register-submit" color="primary" type="submit">
                  <Translate contentKey="global.form.submit">Submit</Translate>
                </Button>
              </AvForm>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ locale, staticPage }: IRootState) => ({
  currentLocale: locale.currentLocale,
  enquirySuccess: staticPage.enquirySuccess
});

const mapDispatchToProps = { onlineEnquiry, reset };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);
